import { ContextType } from 'ui/molecules/Form/types'
import { Context, useContext } from 'react'

export const useCheckRequiredFields = (
  requiredFields: string[],
  context: Context<ContextType>
) => {
  const { values } = useContext<ContextType>(context)

  const checkFields = () =>
    requiredFields.every((key) => {
      if (Array.isArray(values[key])) {
        return values[key].length > 0
      }
      return values[key] !== 'undefined' && values[key] !== ''
    })

  return {
    isDisabledFormButton: !checkFields(),
  }
}
